import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

/* Layout */
import Layout from '@/layout';

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        name: 'dashboard',
        component: () => import('@/views/dashboard'),
        meta: { title: '仪表盘', icon: 'dashboard' }
      }
    ]
  },
  {
    path: '/statistics',
    component: Layout,
    children: [
      {
        path: '',
        name: 'statistics',
        component: () => import('@/views/statistics'),
        meta: { title: '汇总统计', icon: 'dashboard' }
      }
    ]
  },
  {
    path: '/business',
    component: Layout,
    meta: { title: '业务管理', icon: 'dashboard' },
    children: [
      {
        path: '',
        name: 'business-index',
        component: () => import('@/views/business'),
        meta: { title: '业务列表', icon: 'dashboard' }
      },
      {
        path: 'create',
        name: 'business-create',
        component: () => import('@/views/business/create'),
        meta: {
          title: '业务创建',
          icon: 'dashboard',
          activeMenu: '/business'
        },
        hidden: true
      },
      {
        path: 'update',
        name: 'business-update',
        component: () => import('@/views/business/update'),
        meta: {
          title: '业务更新',
          icon: 'dashboard',
          activeMenu: '/business'
        },
        hidden: true
      },
      {
        path: 'detail',
        name: 'business/detail',
        component: () => import('@/views/business/detail'),
        meta: {
          title: '业务详情',
          icon: 'dashboard',
          activeMenu: '/business'
        },
        hidden: true
      }
    ]
  },
  {
    path: '/implementation',
    component: Layout,
    meta: { title: '实施列表', icon: 'dashboard' },
    children: [
      {
        path: '',
        name: 'implementation-index',
        component: () => import('@/views/implementation'),
        meta: { title: '实施列表', icon: 'dashboard' }
      },
      {
        path: 'detail',
        name: 'implementation-detail',
        component: () => import('@/views/implementation/detail'),
        meta: { title: '实施详情', icon: 'dashboard' },
        hidden: true
      },
      
    ]
  },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
];

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
